<template>
  <van-button
      v-bind="$attrs"
      v-on="$listeners"
      class="vg-button"
      :class="[type]"
  >
    <slot></slot>
  </van-button>
</template>

<script>

import {Button} from "vant";
export default {
  name: "VgButton",
  components: {
    'van-button': Button
  },
  props: {
    type: {
      type: String,
      default: "secondary"
    }
  }
}
</script>

<style scoped>
.vg-button {
  display: block;
  /*padding: 8px 18px;*/
  padding: 14px 12px;
  font-size: 16px;
  /*font-weight: 600;*/
  color: #000000;
  line-height: 22px;
  border-radius: 8px;
  border: 1px solid #DFDFDF;
  background-color: #F8F8F8;
}

.vg-button.secondary {
  color: #3268FF;
  border-color: #3268FF;
}

.vg-button.selection {;
  font-size: 12px;
  font-weight: 400;
  color: #333333;
  line-height: 12px;
  box-shadow: 0px 2px 4px 0px rgba(212, 208, 208, 0.5);
  border: 1px solid rgba(50, 104, 255, 0.21);
  background-color: #FFFFFF;
}

.vg-button.warning {
  color: #F45613;
  border-color: #F45613;
}

.vg-button.primary {
  color: #FFFFFF;
  background-color: #4BA9F6;
  border-color: #4BA9F6;
}

.vg-button.small {
  font-size: 14px;
  height: 26px;
  padding: 0 12px;
}


.vg-button {

}

</style>